<template>
  <div>
    <p>说明】您可以在这里填写您所在的课题组研究方向，并添加与之相关的图片，范例如下：</p>
    <p>XXX课题组现阶段主要有两个大的研究方向：</p>
    <p>(1) XXXX技术与机理研究</p>
    <p>(2) XX的XXX理论与技术</p>
  </div>
</template>

<script>
import * as serviceApi from "./api/shuomingcard";
export default {
  name: "shuomingcard",
  data() {
    return {
      loading: false,
      query: {
        page_size: 8,
        current_page: 0,
        order: "id",
        order_type: 0,
        evaluate: null,
        content: ""
      },
      tableData: [],
      multipleSelection: [],
      delList: [],
      editVisible: false,
      pageTotal: 0,
      editForm: {},
      editFormRules: {
        business_name: [
          { required: true, message: "请输入商家名称", trigger: "blur" },
          { min: 2, max: 20, message: "长度在 2 到 20 个字符" }
        ],
        business_address: [
          { required: true, message: "请输入商家地址", trigger: "blur" },
          { min: 2, max: 100, message: "长度在 2 到 100 个字符" }
        ],
        phone: [
          { required: true, message: "请输入商家联系方式", trigger: "blur" },
          {
            pattern: /^0{0,1}(13[0-9]|15[7-9]|153|156|18[7-9])[0-9]{8}$/,
            message: "手机号格式不对",
            trigger: "blur"
          }
        ],
        linkman: [
          { required: true, message: "请输入商家联系人姓名", trigger: "blur" },
          { min: 2, max: 20, message: "长度在 2 到 20 个字符" }
        ],
        remark: [{ min: 2, max: 500, message: "长度在 2 到 500 个字符" }]
      },
      addVisible: false,
      addForm: {
        business_name: "",
        business_address: "",
        phone: "",
        linkman: "",
        evaluate: null,
        remark: ""
      },
      addFormRules: {
        business_name: [
          { required: true, message: "请输入商家名称", trigger: "blur" },
          { min: 2, max: 20, message: "长度在 2 到 20 个字符" }
        ],
        business_address: [
          { required: true, message: "请输入商家地址", trigger: "blur" },
          { min: 2, max: 100, message: "长度在 2 到 100 个字符" }
        ],
        phone: [
          { required: true, message: "请输入商家联系方式", trigger: "blur" },
          {
            pattern: /^0{0,1}(13[0-9]|15[7-9]|153|156|18[7-9])[0-9]{8}$/,
            message: "手机号格式不对",
            trigger: "blur"
          }
        ],
        linkman: [
          { required: true, message: "请输入商家联系人姓名", trigger: "blur" },
          { min: 2, max: 20, message: "长度在 2 到 20 个字符" }
        ],
        remark: [{ min: 2, max: 500, message: "长度在 2 到 500 个字符" }]
      },
      showMoreContent: false,
      moreContent: ""
    };
  },
  created() {
    // this.getData();
  },
  methods: {
    // 分页导航
    handlePageChange(val) {
      this.query.current_page = val;
      this.getData();
    },
    // 获取数据列表
    getData() {
      this.loading = true;
      serviceApi.getDataList(this.query).then(res => {
        if (res.success) {
          this.tableData = res.data.list_data;
          this.pageTotal = res.data.total_num;
          //查看更多备注
          this.tableData.forEach(element => {
            element.is_show = 0;
            if (element.remark != null) {
              if (element.remark.length > 8) {
                element.remark_slice = element.remark.slice(0, 5);
                element.is_show = 1;
              }
            } else {
              element.remark = "-";
            }
          });
          this.loading = false;
        }
      });
    },
    // 触发搜索按钮
    handleSearch() {
      this.getData();
    },
    //重置搜索
    resetSearch() {
      this.query.content = "";
      this.query.evaluate = null;
      this.getData();
    },
    //清空添加表单
    resetForm(formName) {
      this.addForm = {
        business_name: "",
        business_address: "",
        phone: "",
        linkman: "",
        evaluate: null,
        remark: ""
      };
    },
    //添加之前
    addBefor() {
      this.addVisible = true;
      this.resetForm("addForm");
    },
    //添加
    add(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          serviceApi.addData(this.addForm).then(res => {
            if (res.success) {
              this.addVisible = false;
              this.$message.success(res.msg[0]);
              this.getData();
            } else {
              var str = "";
              res.msg.forEach(element => {
                str = str + element + "<br/>";
              });
              this.$message({
                type: "error",
                dangerouslyUseHTMLString: true,
                message: str
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 删除操作
    handleDelete(ids) {
      // 二次确认删除
      this.$confirm("确定要删除吗？", "提示", {
        type: "warning"
      })
        .then(() => {
          serviceApi.deleteData({ ids: ids }).then(res => {
            if (res.success) {
              this.$message.success(res.msg[0]);
              this.getData();
              this.multipleSelection = [];
            } else {
              this.$message({
                type: "error",
                dangerouslyUseHTMLString: true,
                message: res.msg[0]
              });
            }
          });
        })
        .catch(() => {});
    },
    // 多选操作
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //批量删除
    delAllSelection() {
      const length = this.multipleSelection.length;
      let ids = [];
      this.multipleSelection.forEach(element => {
        ids.push(element.id);
      });
      this.handleDelete(ids);
    },
    // 编辑操作
    handleEdit(row) {
      serviceApi.getById({ id: row.id }).then(res => {
        if (res.success) {
          this.editForm = res.data;
          this.editVisible = true;
        }
      });
    },
    // 保存编辑
    saveEdit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          serviceApi.editData(this.editForm).then(res => {
            if (res.success) {
              this.$message.success(res.msg[0]);
              this.getData();
              this.editVisible = false;
            } else {
              var str = "";
              res.msg.forEach(element => {
                str = str + element + "<br/>";
              });
              this.$message({
                type: "error",
                dangerouslyUseHTMLString: true,
                message: str
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //查看更多
    showMore(content) {
      this.moreContent = content;
      this.showMoreContent = !this.showMoreContent;
    }
  }
};
</script>

<style scoped>
p{
  margin: 40px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/page/shuomingcard/shuomingcard.vue